import qs from '@scoir/query-string'
import { isUndefined } from 'lodash'

export const getCareerUrl = () => `${import.meta.env.BASE_URL}/discover/search/careers`

export const getCareerSearchURL = (params) =>
  `${getCareerUrl()}${!isUndefined(params) ? '?' + qs.stringify(params) : ''}`
